module.exports = __webpack_public_path__ + "static/img/dd-customer-06.f4721fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-06.jpg
// module id = 8i27
// module chunks = 1